import { OnInit, Component, Output, EventEmitter, Input } from '@angular/core';
import {
  AbstractControl,
  AsyncValidatorFn,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { IJobAlertSettings } from '../../interfaces/job-alert-settings';
import { JobAlertService } from '../../services';
import { compare } from 'fast-json-patch';
import { TaskTypeService } from '../../services';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng';
import { Message } from '../../classes/Message';
import { LocationService } from '../../services';
import { debounceTime, distinctUntilChanged, map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AddressAutoCompletionService } from '../../services/address-auto-completion.service';

@Component({
  selector: 'job-alert-settings-edit',
  templateUrl: './job-alert-settings-edit.component.html',
  styleUrls: ['./job-alert-settings-edit.component.scss'],
})
export class JobAlertSettingsEditComponent implements OnInit {
  public editForm: UntypedFormGroup;
  public _editMode: boolean;
  public _canDelete: boolean;
  public _defaultSettings: boolean = false;
  public originalSettings: IJobAlertSettings;
  fixedTitle: boolean = false;

  @Input('canDelete')
  set canDelete(value: any) {
    this._canDelete = value;
  }

  @Input('defaultSettings')
  set adminMode(value: any) {
    this._defaultSettings = value;
  }

  @Output('editModeChange') editModeChange = new EventEmitter<boolean>();

  @Input('editMode')
  set editMode(value: any) {
    this._editMode = value;
    this.editModeChange.emit(value);
  }

  get editMode(): any {
    return this._editMode;
  }

  public noticePeriodHoursChoices = [
    { label: '0 hrs', value: -999 },
    { label: '12 hrs', value: 12 },
    { label: '24 hrs', value: 24 },
    { label: '36 hrs', value: 36 },
    { label: '48 hrs', value: 48 },
    { label: '60 hrs', value: 60 },
    { label: '72 hrs', value: 72 },
  ];

  public weekDayChoices = [
    { label: 'Mon', value: 1 },
    { label: 'Tue', value: 2 },
    { label: 'Wed', value: 3 },
    { label: 'Thu', value: 4 },
    { label: 'Fri', value: 5 },
    { label: 'Sat', value: 6 },
    { label: 'Sun', value: 7 },
  ];

  public fuelTypeChoices = [
    { label: 'Petrol', value: 'petrol' },
    { label: 'Diesel', value: 'diesel' },
    { label: 'Electric', value: 'electric' },
    { label: 'Hybrid', value: 'hybrid' },
  ];

  public amPmChoices = [
    { label: 'AM', value: 'AM' },
    { label: 'PM', value: 'PM' },
  ];

  //public movementTypeChoices: SelectItem[] = [];

  public alertSettingList: IJobAlertSettings[] = [];
  public alertSetting: IJobAlertSettings;
  public settingsLoaded: boolean = false;
  tabViewIndex: number = 0;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private jobAlertService: JobAlertService,
    private confirmationService: ConfirmationService,
    private taskTypeService: TaskTypeService,
    private locationService: LocationService,
    private messageService: MessageService,
    private addressAutoCompletionService: AddressAutoCompletionService,
  ) {}

  async ngOnInit() {
    this.initForm();
    //this.getMovementTypes();
  }

  deleteSelected(id: number) {
    console.log('CONFIRMING');
    this.confirmationService.confirm({
      message: 'Confirm Job Alert DELETE Request',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteSetting(id).then(() => {
          this.messageService.add(Message.Success('Deleted sucessfully'));
        });
      },
    });
  }

  initForm() {
    try {
      this.editForm = this.formBuilder.group({
        id: [''],
        settingName: ['', [Validators.required]],
        dateFrom: [],
        dateTo: [],
        distanceToPickup: [10],
        distanceToDropoff: [10],
        minValue: [50],
        //movementTypesSelected: [[]],
        noticePeriodHours: [24],
        weekDays: [[1, 2, 3, 4, 5]],
        distanceRange: [[0, 600]],
        timeRange: [[7, 18]],
        alertTimeRange: [[0, 24]],
        fuelTypeList: [['petrol', 'diesel', 'electric']],
        collectionAMPM: [['AM', 'PM']],
        deliveryAMPM: [['AM', 'PM']],
        returnJourneyMovements: [false],
        followOnMovements: [false],
        alertForAllJobs: [true],
        alertAbovePercentage: [40],
        enabled: [true],
      });

      if (!this._defaultSettings) {
        this.editForm.addControl(
          'pickupLocationPostcode',
          new UntypedFormControl('', { asyncValidators: this.postcodeValid(), updateOn: 'blur' }),
        );
        this.editForm.addControl(
          'dropoffLocationPostcode',
          new UntypedFormControl('', { asyncValidators: this.postcodeValid(), updateOn: 'blur' }),
        );
      }
    } catch (error) {
      console.log(error);
    }
  }

  noticePeriodHoursChanged() {}

  /*
  getMovementTypes() {

    this.taskTypeService.get().then((result: ITaskType[]) => {

      this.movementTypeChoices = [];

      let approvedList = [1,2,3,4,8,9,10,11,12];

      result.forEach((v) => {

        if (approvedList.indexOf(v.id) >= 0) {
          this.movementTypeChoices.push({"label": v.abbr, "value": v.id })
        }
      })
    });
  }
   */

  getSupplierSettings() {
    this.jobAlertService.getSupplierSettings().then((x: IJobAlertSettings[]) => {
      this.settingsLoaded = true;
      this.alertSettingList = x;
    });
  }

  disableAlertSetting() {}

  newAlertSetting(settingName: string) {
    this.editAlertSetting(null).then(() => {});

    // Get defaults
    // let x = this.jobAlertService.getDefaultSettings().then((x) => {
    //   x.id = null;
    //   x.settingName = settingName;
    //   x.returnJourneyMovements = false;
    //   x.followOnMovements = false;
    //
    //   this.editAlertSetting(x).then(() => {});
    // });
  }

  async editAlertSetting(x: IJobAlertSettings) {
    this.originalSettings = x;

    if (x) {
      this.fixedTitle = x.settingName == 'Home Job Alert' && !this._defaultSettings;

      try {
        this.editForm.patchValue(x);
      } catch (error) {
        console.log(error);
      }

      let collectionTimes = [];
      if (x.pickupAM) {
        collectionTimes.push('AM');
      }
      if (x.pickupPM) {
        collectionTimes.push('PM');
      }

      let deliveryTimes = [];
      if (x.dropoffAM) {
        deliveryTimes.push('AM');
      }
      if (x.dropoffPM) {
        deliveryTimes.push('PM');
      }

      x.earliestAlertTime = x.earliestAlertTime || 0;
      x.latestAlertTime = x.latestAlertTime || 2400;

      this.editForm.patchValue({
        timeRange: [x.timeFrom / 100, x.timeTo / 100],
        alertTimeRange: [x.earliestAlertTime / 100, x.latestAlertTime / 100],
        distanceRange: [x.distanceMin, x.distanceMax],
        weekDays: x.daysOfTheWeek == null ? null : x.daysOfTheWeek.split(','),
        fuelTypeList: x.fuelTypes == null ? null : x.fuelTypes.split(','),
        //movementTypesSelected: (x.movementTypes == null) ? null : x.movementTypes.split(","),
        deliveryAMPM: deliveryTimes,
        collectionAMPM: collectionTimes,
      });

      if (x.dateFrom != null) {
        this.editForm.patchValue({ dateFrom: new Date(x.dateFrom) });
      }
      if (x.dateTo != null) {
        this.editForm.patchValue({ dateTo: new Date(x.dateTo) });
      }

      this.alertSetting = x;
    } else {
      this.fixedTitle = false;
      this.initForm();
    }

    this.editMode = true;
  }

  saveAlertSetting(e) {
    e.preventDefault();

    if (!this.editForm.valid) {
      return;
    }

    let dto = Object.assign(this.editForm.value);

    /*
    if (dto.movementTypesSelected != null) {
      dto.movementTypes = dto.movementTypesSelected.join(",");
    }

    delete dto.movementTypesSelected;
     */

    // dto.distanceMin = dto.distanceRange[0];
    // dto.distanceMax = dto.distanceRange[1];
    delete dto.distanceRange;

    // Until we have inputs for each, we'll set them to the same
    // dto.distanceToLocation = dto.distanceToPickup;
    // dto.distanceToDropoff = dto.distanceToPickup;

    dto.timeFrom = dto.timeRange[0] * 100;
    dto.timeTo = dto.timeRange[1] * 100;
    //    delete dto.timeRange;

    dto.earliestAlertTime = dto.alertTimeRange[0] * 100;
    dto.latestAlertTime = dto.alertTimeRange[1] * 100;
    //    delete dto.alertTimeRange;

    dto.pickupAM = dto.collectionAMPM.indexOf('AM') >= 0;
    dto.pickupPM = dto.collectionAMPM.indexOf('PM') >= 0;
    delete dto.collectionAMPM;

    dto.dropoffAM = dto.deliveryAMPM.indexOf('AM') >= 0;
    dto.dropoffPM = dto.deliveryAMPM.indexOf('PM') >= 0;
    delete dto.deliveryAMPM;

    dto.daysOfTheWeek = dto.weekDays.join(',');
    delete dto.weekDays;

    dto.fuelTypes = dto.fuelTypeList.join(',');
    delete dto.fuelTypeList;

    if (!this.f.id) {
      this.createAlertSetting(dto).then(() => {
        this.editMode = false;
      });
    } else {
      this.updateAlertSetting(dto).then(() => {
        if (!this._defaultSettings) {
          this.editMode = false;
        } else {
          this.messageService.add(Message.Success('Settings updated'));
        }
      });
    }
  }

  createAlertSetting(dto: IJobAlertSettings): Promise<any> {
    return this.jobAlertService.createSetting(dto).then(() => {});
  }

  updateAlertSetting(dto: IJobAlertSettings): Promise<any> {
    const patch = compare({}, dto);

    return this.jobAlertService.patchSetting(dto.id, patch);
  }

  get f() {
    return this.editForm.value;
  }

  async enableChanged(event, item) {
    let oldDTO = { enabled: !item.enabled };
    let newDTO = { enabled: item.enabled };

    const patch = compare(oldDTO, newDTO);

    await this.jobAlertService.patchSetting(item.id, patch);
  }

  async deleteSetting(id: number) {
    await this.jobAlertService.deleteSetting(id);

    this.editMode = false;
  }

  disabledSwitch() {
    return this.f.dateTo != null && new Date(this.f.dateTo) <= new Date();
  }

  public postcodeValid(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      return this.addressAutoCompletionService.validateAddress(control.value, false).pipe(
        debounceTime(500),
        distinctUntilChanged(),
        take(1),
        map((validationResponse) => {
          if (validationResponse == null || validationResponse.status !== 200) {
            return { error: 'invalid_postcode' };
          }
          return null;
        }),
      );
    };
  }

  showErrors() {
    console.log(this.editForm);
  }
}
